export default {
      id: "about-symbols-04-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-04",
      toString: function () {
        return this.url;
      }
    }